module.exports = __webpack_public_path__ + "img/variables.a03aac2c.svg";